module.exports = __webpack_public_path__ + "static/grafika12@2x-865690b4ecf2e1ab354f4f647eb21dce.png";